
import Main from "./Main";

export default function TelaCadastro(){
    return(
        <>
            <Main/>
        </>
    );
}